'use strict';

var React = require('react');
require('../../../theme/breakpoints.js');
require('imask');
var useRefAndForward = require('../../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var useValidityState = require('../../../hooks/useValidityState.js');
var useBase64Parser = require('./useBase64Parser.js');
var template = require('./template.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FileInput = React.forwardRef(({ onParsed, onParseError, onFileChange, minPendingStateDurationInMs, successStateDurationInMs, onValidityChange, ...props }, ref) => {
    const inputRef = useRefAndForward.useRefAndForward(null, ref);
    if (typeof onParsed !== typeof onParseError) {
        throw new Error('"onParsed" and "onParseError" must be _both_ defined or _both_ undefined.');
    }
    const [parseFile, parserState] = useBase64Parser.useBase64Parser({
        onError: onParseError,
        onResult: onParsed,
        successStateDurationInMs: successStateDurationInMs ?? 2500,
        minPendingStateDurationInMs: minPendingStateDurationInMs ?? 750,
    });
    React.useEffect(() => {
        const input = inputRef.current;
        if (!input) {
            return;
        }
        const inputHasFile = input.files?.[0] !== undefined;
        if (inputHasFile && !props.filename) {
            input.value = '';
        }
    }, [props.filename]);
    const valueMissing = props.required && !props.filename;
    useValidityState.useValidityState({
        onValidityChange,
        getState: React.useCallback(() => ({ valueMissing }), [valueMissing]),
    });
    return (React__default.default.createElement(template.FileInputTemplate, { ...props, ref: inputRef, parserState: parserState, onFileChange: file => {
            onFileChange(file);
            if (file) {
                parseFile(file);
            }
        } }));
});

exports.FileInput = FileInput;
//# sourceMappingURL=component.js.map
